/* eslint-disable react/prop-types */
import React, { useState } from "react"
import { useLocation } from "react-router-dom"

import * as S from "./style"
import { pushToDataLayer } from "../../helpers/gtmManager"

export const getSizeProps = size => {
  const defaultData = {
    width: 96,
    height: 60,
    fontSize: 0.75
  }

  if (!size) return defaultData

  switch (size) {
    case "small": {
      return defaultData
    }
    case "medium":
      return {
        width: 148,
        height: 48,
        fontSize: 0.75
      }
    case "large":
      return {
        width: 250,
        height: 80,
        fontSize: 1.125
      }
    default: {
      return defaultData
    }
  }
}

const LanguageSelector = ({ options, size, isVisible, handleCloseMenu }) => {
  const [areOptionsVisible, setAreOptionsVisible] = useState(false)

  const handleDropdownClick = () => {
    if (isVisible) {
      handleCloseMenu()
    }
    setAreOptionsVisible(!areOptionsVisible)
  }
  const handleMouseLeave = () => setAreOptionsVisible(false)

  const properties = getSizeProps(size)
  const gtmData = { action: "login" }

  const { pathname } = useLocation()

  const currentLanguage = pathname.split("/")[1]

  const filteredOptions = options.filter(x => x.code !== currentLanguage)

  return (
    <S.Button type="button" onMouseLeave={handleMouseLeave} onClick={handleDropdownClick}>
      <S.Flag src={`/assets/icons/languages/${currentLanguage}.png`} alt={currentLanguage} />
      <S.Chevron />
      <S.Options $top={properties.height} $isVisible={areOptionsVisible}>
        {filteredOptions.map((opt, ind) => (
          <S.Option
            key={ind}
            to={`/${opt.code}`}
            $maxHeight={properties.height}
            $bold={opt.code === currentLanguage}
            onClick={() => gtmData && pushToDataLayer(gtmData)}
          >
            <S.Flag src={`/assets/icons/languages/${opt.code}.png`} alt={currentLanguage} />
          </S.Option>
        ))}
      </S.Options>
    </S.Button>
  )
}

export default LanguageSelector
